const links = {
  medium: 'https://medium.com/@mimo.dapp',
  survey: 'https://mka0rhtj4y4.typeform.com/to/wGKcVsW7',
  appStore: 'https://apps.apple.com/us/app/zapry-web3-social-platform/id6443603245?l=en',
  androidApk: 'https://www.zapry.net/dl/Zapry.apk',
  testFlight: 'https://apps.apple.com/us/app/testflight/id899247664',
  mimoTestFlight: 'https://testflight.apple.com/join/mXBP3XoK'
}

export default links